module.exports = __webpack_public_path__ + "static/media/card_2x.934b0176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/new-york-city/card_2x.jpg
// module id = 896
// module chunks = 27